import { Injectable } from '@angular/core'

import { HttpService } from './http.service'
import { PageResultDto } from '../dto'
import { GovernTenantDto, FindGovernTenantDto } from '../dto/governance-admin/tenant.dto'

@Injectable()
export class AdminOfflineTenantService {
  constructor(
    private httpService: HttpService
  ) {
  }

  async find(findOfflineTenantDto: FindGovernTenantDto) {
    return await this.httpService.get<PageResultDto<GovernTenantDto>>('/admin/v1/offline-tenants', findOfflineTenantDto)
  }

  async findOne(id: string) {
    return await this.httpService.get<GovernTenantDto>(`/admin/v1/offline-tenants/${id}`)
  }

  async findByIds(ids: string[]) {
    return await this.httpService.get<GovernTenantDto[]>(`/admin/v1/offline-tenants/ids`, { tenantIds: ids })
  }

  async setAdmin(id: string, ownerIds: string[]) {
    return await this.httpService.put<Boolean>(`/admin/v1/offline-tenants/${id}/admins`, { ownerIds })
  }
}
